async function eventReport (data) {

  const encrypt = new JSEncrypt();

  const publicKey = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA0QZj+0Wd1DDhl22RNO66
gX2hTq6wV/jBfm8yIALxxHbp+PGqWNAShPkgrQ/0PEOdme7cnWYh4N2R9ZN2mIVs
wZ0sichpv/JxPwXMCLnS2XzJBEFKlxiLqr5sjcZXynzsWG5NlS3h4a4SDrBNQVVs
htT5bVkoSWLk25eP2yNBwnd7FIWs4hkwYfgg6PYRu1UKFB/zHrED6zblfma/NkEt
SWvqhg1Tr/gNcTL8D7sVu1TvY1ccIOuDzSHeG5zb/a3YqMbHSzDbpdUTaMHqomiq
W+cKhW5w3B7fjdbxCkfXtV9p23wK9qEEXK86Z6uZ9k9vHD5CkIcrx9Yk2yP1R271
r/r0s1F6ub701ttdAMcgqCzwdIBOAm/V3IiUoU+v3J1MqXXHYscbIkpYmNPfgaKy
56DstewzMut9vv70g/i80pZ5svhoX/wyrc+zlRl/FHHBGoo5EhLuadj0f2+9HGzV
nsWit9V9Z8qaWvL883Vbwy7cneOCepdZa1DhET5KX12CgVy5PZxdkvV7+hFy2pu5
J9w2FNJx1g9O/UAOXDmEczl/Kx1WJc/G9djqRXFavjsLVrOJuG7bVFVQt6nxrnLY
42GkJz8H0Dwr5kaPAf7VS43QfLvdVksWAKkB2bB14mTGHYu8UKEI4SFF7w5o9X8F
N/CBGhK38ssve5kex+LmzysCAwEAAQ==
-----END PUBLIC KEY-----`;

  encrypt.setPublicKey(publicKey);

  const encryptedData = encrypt.encrypt(data);

  try {
    const response = await fetch('https://supportservice.katvr.com/shopify/eventReport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ encryptedData }),
    });

    return await response.json();
  } catch (error) {
    return {}
  }
}

function getDeviceType () {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/mobile/i.test(userAgent)) {
    return 'mobile';
  } else {
    return 'desktop';
  }
}

async function elementClick (data) {
  const submissionTime = new Date().toISOString();
  data.submissionTime = submissionTime;
  const jsonData = JSON.stringify(data);
  return await eventReport(jsonData);
}
